export const InfoMixins = {
    methods:{
        //错误信息
        errorInfo(errorInfo,config={}){
            this.$bvToast.toast(errorInfo, {
                title: '提示信息',
                autoHideDelay: 5000,
                variant:'primary',
                toaster:'b-toaster-top-center',
                appendToast: false,
                ...config
            })
        },
    }
}
